import styled, { css } from 'styled-components'

export const GiftCardContainer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 0px 15px 15px 15px;
  box-sizing: border-box;
  min-height: calc(100vh - 280px);
  transition: all 0.3s ease;

  ${props => props.noPadding && css`
    padding: 0;
  `}

  > img {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    transition: all 0.3s ease;
    border-radius: 12px;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    }
  }

  .gift-card-content {
    width: 90%;
    margin: 0 auto;
    transition: all 0.3s ease;

    h2 {
      transition: all 0.3s ease;
    }

    p {
      transition: all 0.3s ease;
      line-height: 1.6;
    }
  }

  @media (min-width: 768px) {
    width: 85%;

    .gift-card-content {
      width: 70%;
    }
  }
`

export const Title = styled.h1`
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 0px;
  margin-top: 0;
  transition: all 0.3s ease;

  @media (min-width: 1280px) {
    font-size: 36px;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 5px;
  background-color: #E9ECEF;
  margin: 30px 0;
  border-radius: 3px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`

export const Container = styled.div`
  margin-top: 50px;
  margin-bottom: 60px;
  transition: all 0.3s ease;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  transition: all 0.3s ease;

  h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  svg {
    margin: 0 10px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
`

export const ActionWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px 20px;
  background-color: ${props => props.theme.colors.gray300};
  justify-content: space-between;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  .gift-card-text {
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      transition: all 0.3s ease;
    }

    p {
      margin: 0;
      font-size: 14px;
      transition: all 0.3s ease;
    }
  }

  > button {
    height: 35px;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.3s ease;

    &.light {
      background: #E9ECEF;
      border-width: 0px;
      border-radius: 8px;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }

    @media (max-width: 853px) {
      font-size: 12px;
    }
  }

  @media (min-width: 768px) {
    padding: 25px 40px;
  }
`
